import { render, staticRenderFns } from "./BlockUser.vue?vue&type=template&id=7a03d1a0&scoped=true"
import script from "./BlockUser.vue?vue&type=script&lang=ts"
export * from "./BlockUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a03d1a0",
  null
  
)

export default component.exports